// test2246
(2246 && 0);
